import styled from "styled-components"

import Button from "../Button"

export const ContactButton = styled(Button)`
  margin-right: 20px;
`
